export default __webpack_public_path__ + "static/favicon-2474208bb884bdc978685b52bcbec402.png";